/**
 * Fixes malformed html by removing divs and wrapping text nodes in p tags
 * If content is malformed, it will crash the editor. This will clean it
 * up and fix as much as possible to recover broken html.
 */
export const fixMalformedHtml = (html: string): string => (html
  // New lines add extra paragraphs but they should have no effect
  .replace(/\\n/g, '')
  // In some cases extra escapes have been added
  .replace(/\\/g, '')
  // <divs /> make a mess of content and can wrap multiple children.
  // Removing them now simplifies the next step of wrapping or changing
  // tags of elements. This removes opening and closing divs and all attributes.
  // See: regexr.com/7fq4m
  // `<div` => Match opening divs
  // `(\s+[a-z_-]+` => Attribute names e.g. `class` or `data-x`
  // `(=("[^"]+"|'[^']+'|[a-z_0-9]+))?` => Matches the attribute value (? at end can
  //     match attributes with no value) `="foo-bar"` or `='foo bar'` or `=foo_bar`
  // `)*\s*>` => Allow for multiple or no attributes. Consume any spaces after attributes
  //     and capture closing tag.
  .replace(/<div(\s+[a-z_-]+(=("[^"]+"|'[^']+'|[a-z_0-9]+))?)*\s*>/gi, '<br/>')
  // Match closing divs
  .replace(/<\/div\s*>/gi, '')
);

/*
 * Lexical can only use a subset of element types on the top level
 * i.e. direct children of `dom.body`.
 * All other elements need to be converted to a supported tag (p)
 * or they need to be wrapped by a supported tag (in the case of
 * text nodes which have no tag).
 *
 * Elements Lexical supports at the top level: <p>, <ul>
 *
 * This affects the original dom object
 */
export const replaceWithSupportedTags = (dom: Document): void => {
  const supportedElements = ['p', 'ul'];
  // Use childNodes to capture unwrapped text elements
  dom.body.childNodes.forEach((node: HTMLElement) => {
    if (supportedElements.includes(node.nodeName.toLowerCase())) {
      return;
    }
    const p = document.createElement('p');
    p.innerHTML = node.innerHTML ?? node.textContent;
    node.replaceWith(p);
  });
};
